// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".center[data-v-557bcd77]{display:block;margin-left:auto;margin-right:auto;overflow:hidden;width:100%}.v-card__text[data-v-557bcd77],.v-dialog.v-dialog--active[data-v-557bcd77]{margin:0;padding:0}.content[data-v-557bcd77]{display:block;height:auto;margin-left:auto;margin-right:auto;overflow:hidden;position:relative;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
